"use client";

import { convertToLocale } from "@lib/util/money";
import type { StoreCart } from "@medusajs/types";
import Link from "next/link";
import ButtonCustom from "../../button-custom";

type Props = {
  cart:
    | (StoreCart & {
        total?: number | null;
        subtotal?: number | null;
        tax_total?: number | null;
        shipping_total?: number | null;
        discount_total?: number | null;
        gift_card_total?: number | null;
        currency_code: string;
        shipping_subtotal?: number | null;
      })
    | null;
  onClose: () => void;
};

const FooterCart = ({ cart, onClose }: Props) => {
  if (!cart || (cart?.items && cart.items.length === 0))
    return (
      <div className="p-4">
        <Link href="/">
          <ButtonCustom onClick={onClose}>Mua sắm ngay</ButtonCustom>
        </Link>
      </div>
    );

  const { currency_code, original_item_total = 0 } = cart;

  return (
    <div className="p-4 z-50">
      <div className="flex items-center justify-between text-ui-fg-base mb-2 txt-medium">
        <span className="text-xl text-primary-color">Tổng tạm tính</span>
        <span className="text-xl text-primary-color" data-testid="cart-total" data-value={original_item_total}>
          {convertToLocale({ amount: original_item_total, currency_code })}
        </span>
      </div>

      <Link href="/checkout">
        <ButtonCustom onClick={onClose}>Thanh toán</ButtonCustom>
      </Link>
    </div>
  );
};

export default FooterCart;
